module.exports = __webpack_public_path__ + "img/pauli-z-root-5.aa0e498f.svg";